import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "6", x: "5", y: "4", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "6", x: "11", y: "14", rx: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Ungroup";
const Ungroup = memo(themed(Icon));
export {
  Ungroup
};
//# sourceMappingURL=ungroup.js.map
